import axiosInstance from '../utils/AxiosConfig';

// Lado Axium-staff ("ops"): bandeja de conversaciones de soporte de empresas.
// Migrado desde /courier/support/companies/... (el paquete courier fue eliminado del backend)
// a /support/company/operations/... . Nota: esta migración perdió el push en tiempo real por
// WebSocket hacia el staff; ahora solo dispara un email de notificación preexistente cuando una
// empresa escribe. Si esta bandeja se vuelve a exponer en el dashboard, la UI que la consuma debe
// refrescar por polling/botón de refresco manual en lugar de esperar un evento realtime.
export const getCompanySupportConversations = async () => {
  const response = await axiosInstance.get('/support/company/operations/conversations');
  return response.data || [];
};

export const getCompanySupportMessages = async (companyId, userEmail) => {
  const response = await axiosInstance.get(`/support/company/operations/conversations/${companyId}/messages`, {
    params: { userEmail },
  });
  return response.data || [];
};

export const sendCompanySupportReply = async (companyId, userEmail, message) => {
  const response = await axiosInstance.post(
    `/support/company/operations/conversations/${companyId}/messages`,
    { message },
    { params: { userEmail } }
  );
  return response.data;
};

// Lado empresa (cliente Axium): sin cambios respecto al backend.
export const getMyCompanySupportMessages = async () => {
  const response = await axiosInstance.get('/support/company/messages');
  return response.data || [];
};

export const sendMyCompanySupportMessage = async (message) => {
  const response = await axiosInstance.post('/support/company/messages', { message });
  return response.data;
};
